"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../fetch");
// tslint:disable-next-line: no-var-requires
var Md5 = require('../md5').Md5;
var Sha1 = require('../sha1').default;
/**
 * 服务基类
 */
var BaseService = /** @class */ (function () {
    function BaseService() {
        var _this = this;
        this.isSecurity = true;
        this.signKey = '';
        this.fetch = function (type) {
            if (type === void 0) { type = 'app'; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var me, postBody, params, headers;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            me = this;
                            if (!(type === 'app')) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.createParams()];
                        case 1:
                            postBody = _a.sent();
                            // tslint:disable-next-line:no-console
                            return [2 /*return*/, this.fetchEntity.fetch(postBody).then(function (result) {
                                    // tslint:disable-next-line: no-debugger
                                    me.responseParams = result;
                                    return result;
                                })];
                        case 2:
                            params = this.getRequestParams();
                            headers = {};
                            if (this.method !== fetch_1.Methods.GET) {
                                headers['signature'] = this.getSignature(this.getRequestParams(), 'SH1');
                            }
                            return [2 /*return*/, this.fetchEntity.fetch(params, headers).then(function (result) {
                                    // tslint:disable-next-line: no-debugger
                                    me.responseParams = result;
                                    return result;
                                })];
                    }
                });
            });
        };
        this.createParams = function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var head, body, postParams, plainText, cipherText, postBody, postForm, key, data;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        head = {
                            service: this.code,
                            token: this.isSecurity && BaseService.loginUser ? BaseService.loginUser.token : '',
                            userCode: this.isSecurity && BaseService.loginUser ? BaseService.loginUser.loginName : '',
                            nonceStr: this.uuid && this.uuid()
                        };
                        body = this.getRequestParams() || {};
                        if (this.isSecurity && BaseService.loginUser) {
                            head.userCode = BaseService.loginUser.loginName;
                        }
                        postParams = { head: head, body: body };
                        plainText = JSON.stringify(postParams);
                        return [4 /*yield*/, this.encrypt(plainText)];
                    case 1:
                        cipherText = _a.sent();
                        postBody = { plainText: plainText, cipherText: cipherText };
                        if (this.method === fetch_1.Methods.POSTFILE) {
                            postForm = [];
                            postForm.push({ name: 'plainText', data: plainText });
                            postForm.push({ name: 'cipherText', data: cipherText });
                            // tslint:disable-next-line:forin
                            for (key in body) {
                                data = body[key];
                                if (data.constructor.name === 'File' || typeof data !== 'object') {
                                    postForm.push({ data: data, name: key });
                                }
                                else {
                                    data['name'] = key;
                                    postForm.push(data);
                                }
                            }
                            return [2 /*return*/, postForm];
                        }
                        else {
                            return [2 /*return*/, postBody];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    BaseService.prototype.createFetch = function (baseInfo, Fetch) {
        // @ts-ignore
        this.fetchEntity = new Fetch((0, tslib_1.__assign)((0, tslib_1.__assign)({}, baseInfo), { code: this.code, method: this.method }));
        return this;
    };
    BaseService.prototype.getRequestParams = function () {
        return this._getRequestParams(this.requestParams) || {};
    };
    BaseService.prototype._getRequestParams = function (params) {
        var _this = this;
        var newParams = {};
        Object.keys(params).map(function (item) {
            var obj = params[item];
            if (obj && obj.constructor.name === 'File') {
                newParams[item] = obj;
            }
            else if (obj && obj.constructor.name === 'ENUM') {
                newParams[item] = obj.value.key;
            }
            else if (obj && obj.constructor.name === 'Date') {
                newParams[item] = obj;
            }
            else if (obj && typeof obj === 'object') {
                if (Array.isArray(obj)) {
                    newParams[item] = obj;
                }
                else {
                    newParams[item] = _this._getRequestParams(obj);
                }
            }
            else {
                newParams[item] = (obj === null || obj === undefined) ? '' : obj;
            }
        });
        return newParams;
    };
    BaseService.prototype.getSignature = function (params, type) {
        if (type === void 0) { type = 'md5'; }
        var newParams = this.sortKeys(params);
        return type === 'md5' ? Md5(JSON.stringify(newParams)) : Sha1(JSON.stringify(newParams));
    };
    BaseService.prototype.sortKeys = function (params) {
        var newParams = {};
        Object.keys(params).sort().forEach(function (key) {
            var newValue = params[key];
            if (typeof newValue === 'object') {
                // newParams[ key ] = this.sortKeys(newValue)
                newParams[key] = newValue;
            }
            else {
                newParams[key] = newValue;
            }
        });
        return newParams;
    };
    return BaseService;
}());
exports.BaseService = BaseService;
//# sourceMappingURL=service.js.map